import React from 'react';
import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './Chronology.css';
import Flag from '@material-ui/icons/Flag';
import { Link } from 'react-router-dom';
import { urls } from '../router/urls';

const ChronologyDescription = ({ data }) => {
  return (
    <div className="options" style={{ background: 'rgba(0,0,0,0.07)' }}>
      <VerticalTimeline>
        {data['grouping_resources'].map((elemento, index) => {
          return (
            <VerticalTimelineElement
              key={index}
              className="vertical-timeline-element--work"
              date={elemento['chronology_date']}
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              icon={<Flag />}
            >
              <h3 className="vertical-timeline-element-title">
                <Link
                  to={`/${urls.recursos}/${elemento['resource_grouped']}`}
                  title={elemento['title']}
                >
                  {elemento['title']}
                </Link>
              </h3>

              <p>
                <img
                  src={urls.url_api + elemento['image']}
                  alt="logo"
                  aria-roledescription="logo"
                  style={{ width: '100%' }}
                />
              </p>
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
};

export default ChronologyDescription;
